// extracted by mini-css-extract-plugin
export default {"root":"plain-link_root__mWVTo","disabled":"plain-link_disabled__RGhyf","placeHolderShimmer":"plain-link_placeHolderShimmer__VnJYs"};